import React from "react";
import Body from "./Body";
import { useParams } from "react-router-dom";

const ExamDetails = () => {
  const location=useParams()
  
  console.log(location.id);
  
  return <Body />;
};

export default ExamDetails;
